import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseWidgetModule } from './widget/widget.module';


@NgModule({
  imports: [
    CommonModule,
    FuseWidgetModule
  ],
  declarations: [],
  exports:[FuseWidgetModule]
})
export class PostItemModule { }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/post-item/post-item.module.ts